export default __webpack_public_path__ + "static/media/Fill2.bd61cad0.svg";